import { createStep, TextInput } from '@/Components/formik-steps'
import LicensePlate from '@/Components/LicensePlate'
import { useForm } from '@/Components/formik-steps'
import * as yup from 'yup'
import { useError } from '@/Components/formik-steps/Error'


function LicensePlateStep() {
    const error = useError('license')

    const { values, setFieldValue } = useForm()

    return (
        <>
            <h1 className="text-[#070707] text-[40px] font-inter font-bold leading-[normal] tracking-[0.4px] mb-[24px]">
                Waar heb je hulp bij nodig?
            </h1>
            <p className="text-[rgba(7,7,7,0.80)] font-inter text-[17px] font-normal leading-[normal] tracking-[0.17px] mb-[36px]">
                Doorloop de stappen hieronder om een afspraak in te plannen.
            </p>
            <p className="text-[#070707] font-inter text-2xl font-semibold leading-[normal] tracking-[0.24px] mb-[24px]">
                Vul jouw kenteken in
            </p>

            <div className="mb-[24px]">
                <LicensePlate countryCode="NL" height={64} />
                {error && <p className='text-red-500'>{error}</p>}
                {values.errors.map((error) => <div>{error}</div>)}
            </div>

            <div className="flex justify-start mb-3">
                {!values.license_found && (
                    <button
                        className="inline-flex bg-white border rounded-[8px] border-red-700 text-red-700 px-2 py-1 hover:bg-red-700 hover:text-white active:bg-red-900 active:text-white focus:outline-none transition-all duration-300 cursor-pointer"
                        type="button"
                        onClick={() => {
                            setFieldValue('manual_fill', true);
                        }}>
                        Kenteken handmatig invullen
                    </button>
                )}
            </div>

            <div className='inline-flex flex-col gap-y-4 mb-[100px]'>
                {(values.brand || values.manual_fill) && (
                    <TextInput name='brand' placeholder='Merk' onChange={(value) => setFieldValue('brand', value)} disabled={values.license_found} />
                )}

                {(values.build || values.manual_fill) && (
                    <TextInput name='build' placeholder='Model' onChange={(value) => setFieldValue('build', value)} disabled={values.license_found} />
                )}

                {(values.license_found || values.manual_fill) && (
                    <TextInput name='mileage' placeholder='KM stand' type="number" onChange={(value) => setFieldValue('milage', value)} min={0} max={10000000} />
                )}
            </div>
        </>
    )
}

export default createStep({
    component: <LicensePlateStep />,
    validation: {
        license: yup.string().required('Kenteken is verplicht').min(5),
        brand: yup.string().required('Merk is verplicht').min(2),
        build: yup.string().required('Model is verplicht').min(2),
        mileage: yup.string().required('Kilometerstand is verplicht').min(0),
    }
})
